import React from 'react';
import Sidebar from '../../components/Super Admin/SideBar/Sidebar';
import Tabs from '../../components/Super Admin/TopBar/TopbarPayments';
import CouponCodeList from '../../components/Super Admin/Payment/CouponCodeList';
import '../../css/FeeConfigPage.css';

const CouponCodePage: React.FC = () => {
  return (
    <>
        <Tabs activeTab="coupon" />
        <CouponCodeList />
    </>
  );
};

export default CouponCodePage;
